module.exports = " <div class=\"\"> <div class=row> <div class=col-sm-2> <input v-model=filterKey placeholder=Search... class=form-control> </div> <div class=col-sm-10> <button class=\"btn btn-default\" @click=clearSearch>Limpiar</button> </div> </div> <br> <div class=row> <div class=col-md-12> <players-table :players=players :filter-key.sync=filterKey :list-type=listType></players-table> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayersInGame.vue
 ** module id = 292
 ** module chunks = 1
 **/